import type { PaginationRequest } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import baseFetcher from '@aibees/shared/http/fetcher/base-fetcher';
import { useBrowsePresetApi } from './use-browse-preset-api';
import { PRESET_API_PREFIX } from './constants';

type BrowsePresetParams = PaginationRequest<{
  type: string | string[];
  name?: string | null;
}>;

function buildKeyAndConfig(workspaceId: string, params: BrowsePresetParams) {
  const page = params.page ?? 0;
  const size = params.size ?? 5;
  const name = params.name ?? undefined;
  const { type, name: _n, ...rest } = params;
  const filters = { ...rest, page, size };
  const queryKey = [useBrowsePresetApi.name, type, name, filters] as const;
  const requestParams = { ...params, page, size, name };
  const config = {
    url: PRESET_API_PREFIX.replace(':id', String(workspaceId)),
    params: requestParams,
  };
  return { queryKey, config };
}

/**
 * Prefetch a browse preset query so that when useBrowsePresetApi (or useGetSinglePresetApi)
 * runs with the same params it gets a cache hit. Uses the same query key and fetcher as useBrowsePresetApi.
 */
export async function prefetchBrowsePreset(
  workspaceId: string,
  params: BrowsePresetParams
): Promise<void> {
  const { queryKey, config } = buildKeyAndConfig(workspaceId, params);
  await baseQueryClient.prefetchQuery({
    queryKey,
    queryFn: () => baseFetcher({ ...config }),
  });
}
